import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { apiGet, apiPost } from '../../../API/Api_Url';
import { FaEdit, FaEye, FaPlus, FaTrashAlt } from 'react-icons/fa';
import { Calendar, CheckCircle, DollarSign, MapPin, Package, Truck, XCircle } from 'lucide-react';
import UpdateMaterialRequestModel from '../../Modal/UpdateMaterialRequestModel';
import DeleteMaterialRequestModel from '../../Modal/DeleteMaterialRequestModel';
import { toast } from 'react-toastify';

function UserAllPendingMaterialRequest({ RequirementState, setRequirementState }) {
    const navigate = useNavigate();
    const [MaterialRequest, setMaterialRequest] = useState([]);
    const [isUploading, setIsUploading] = useState(false);

    const GetUserAllPendingMaterialRequest = async () => {
        try {
            setIsUploading(true);
            const response = await apiGet('api/user/UserGetStatusWiseAllMaterialRequest?status=Pending');
            setMaterialRequest(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsUploading(false);
        }
    };

    useEffect(() => {
        GetUserAllPendingMaterialRequest();
    }, []);

    const getStatusColor = (status) => {
        switch (status) {
            case 'Pending':
                return 'bg-yellow-100 text-yellow-800 border-yellow-200';
            case 'Accepted':
                return 'bg-green-100 text-green-800 border-green-200';
            case 'Rejected':
                return 'bg-red-100 text-red-800 border-red-200';
            default:
                return 'bg-gray-100 text-gray-800 border-gray-200';
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const [UpdateModel, setUpdateModel] = useState(false);
    const [SelectedReq, setSelectedReq] = useState(null);

    const OpenUpdateModel = (req) => {
        setSelectedReq(req)
        setUpdateModel(true)
    }

    const CloseUpdateModel = () => {
        setSelectedReq(null)
        setUpdateModel(false)
    }


    const [DeleteModel, setDeleteModel] = useState(false);

    const OpendeleteModel = (req) => {
        setDeleteModel(true)
        setSelectedReq(req)
    }

    const CloseDeleteModel = () => {
        setDeleteModel(false)
        setSelectedReq(null)
    }

    const [Allbids, setAllbids] = useState([]);
    const [IsbidLoading, setIsbidLoading] = useState(false);

    const GetAllbidofMaterialRequest = async (id) => {
        try {
            setIsbidLoading(true)
            const response = await apiGet(`api/user/UsergetAllBidsofMaterialRequest/${id}`);
            setAllbids(response?.data);
            setIsbidLoading(false)
        } catch (error) {
            setIsbidLoading(false)
            console.error('Error fetching data:', error);
        } finally {
            setIsbidLoading(false)
        }
    };



    const [expandedJob, setExpandedJob] = useState(null);

    const toggleBids = async (reqId) => {
        if (expandedJob === reqId) {
            setExpandedJob(null);
            setAllbids([]);
        } else {
            await GetAllbidofMaterialRequest(reqId);
            setExpandedJob(reqId);
        }
    };


    
    const UserSelectMaterialSupplierBid = async (requestId, bidId) => {
        try {
            const data = {
                requestId,
                bidId
            }
            setIsUploading(true);
            const response = await apiPost('api/user/UserSelectMaterialSupplierBid', data);
            toast.success(response?.message || 'Quotetion seleceted completed')
            GetUserAllPendingMaterialRequest()
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsUploading(false);
        }
    };

    return (
        <div className="p-6 bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen">
            <div className="max-w-7xl mx-auto">
                <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between">
                    <div>
                        <h1 className="text-3xl font-bold text-gray-900 mb-1 md:mb-0">
                            My All Material Requests
                        </h1>
                        <p className="text-gray-600">Manage and track your Material Requests</p>
                    </div>
                    <div className="flex items-center gap-4 mt-4 md:mt-0">
                        <select
                            value={RequirementState}
                            onChange={(e) => setRequirementState(e.target.value)}
                            className="border border-gray-300 rounded-lg px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#0060B9]"
                        >
                            <option value="All">All</option>
                            <option value="pending">Pending</option>
                            <option value="SupplierSelected">Supplier Selected</option>
                            <option value="Confirmed">Supplier Confirmed</option>
                            <option value="InTransit"> Material In Transit</option>
                            <option value="Delivered">Delivered</option>
                            <option value="RejectedAndReturn">Rejected And Return</option>
                            <option value="Completed">Completed</option>
                        </select>
                    </div>

                </div>

                {isUploading ? (
                    <div className="flex items-center justify-center py-20">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                        <p className="ml-4 text-gray-600">Loading your projects...</p>
                    </div>
                ) : MaterialRequest?.length === 0 ? (
                    <div className="text-center py-20">
                        <p className="text-xl text-gray-500">No Material Requests found.</p>
                        <p className="text-gray-400 mt-2">Create your first job post to get started.</p>
                    </div>
                ) : (
                    <div className="grid gap-6 grid-cols-1">
                        {MaterialRequest?.map((req) => (
                            <div key={req?._id} className="bg-white rounded-2xl shadow-lg p-6">
                                <div className="flex justify-between items-start mb-4">
                                    <h3 className="text-xl font-bold text-gray-900">
                                        Material Request #{req?._id?.slice(-6)}
                                    </h3>
                                    <span
                                        className={`px-3 py-1 text-xs font-semibold rounded-full border ${getStatusColor(
                                            req?.Status
                                        )}`}
                                    >
                                        {req?.Status}
                                    </span>
                                </div>
                                {req?.location && (
                                    <div className="flex items-start text-gray-600 mb-4">
                                        <MapPin className="h-4 w-4 mr-2 mt-0.5 text-blue-500" />
                                        <p className="text-sm">
                                            {req?.location?.Address}, {req?.location?.City},{" "}
                                            {req?.location?.State}
                                        </p>
                                    </div>
                                )}
                                <div className="flex items-center text-gray-700 text-sm mb-3">
                                    <Calendar className="h-4 w-4 mr-2 text-orange-500" />
                                    <p>
                                        <span className="font-medium">Delivery Date:</span>{" "}
                                        {formatDate(req?.deliveryDate)}
                                    </p>
                                </div>
                                <div className="mt-4">
                                    <h4 className="font-semibold text-gray-800 mb-2 flex items-center">
                                        <Package className="h-4 w-4 mr-2 text-green-500" />
                                        Material Items
                                    </h4>
                                    <div className="space-y-3">
                                        {req?.MaterialItems?.map((item, i) => (
                                            <div key={i} className="bg-gray-50 border border-gray-200 p-4 rounded-xl flex flex-col sm:flex-row sm:items-center justify-between">
                                                <div>
                                                    <p className="text-sm font-semibold text-gray-800">
                                                        {item?.materialName}
                                                    </p>

                                                    <p className="text-xs text-gray-500">
                                                        Qty: {item?.quantity} {item?.unit} | Specs: {item?.specifications}
                                                    </p>

                                                    {item?.brandPreference && (
                                                        <p className="text-xs text-blue-600 font-medium mt-1">
                                                            Brand Preference: {item?.brandPreference}
                                                        </p>
                                                    )}
                                                </div>
                                                <div className="flex flex-wrap gap-2 mt-2 sm:mt-0">
                                                    <span className="bg-gray-200 text-gray-700 text-xs px-3 py-1 rounded-full shadow-sm">
                                                        {item?.unit}
                                                    </span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="mt-4 flex justify-between items-center text-sm text-gray-500">
                                    <span className="flex items-center">
                                        <Calendar className="h-4 w-4 mr-1" />
                                        Created: {formatDate(req?.createdAt)}
                                    </span>
                                    <div className="flex items-center gap-2">
                                        <button
                                            onClick={() => OpenUpdateModel(req)}
                                            className="flex items-center gap-1 px-3 py-1 text-sm bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
                                        >
                                            <FaEdit className="h-4 w-4" />
                                            Update
                                        </button>

                                        <button
                                            onClick={() => OpendeleteModel(req)}
                                            className="flex items-center gap-1 px-3 py-1 text-sm bg-red-500 text-white rounded-lg hover:bg-red-600 transition"
                                        >
                                            <FaTrashAlt className="h-4 w-4" />
                                            Delete
                                        </button>

                                        <button
                                            className="flex items-center gap-1 px-3 py-1 text-sm bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition"
                                        >
                                            <FaEye className="h-4 w-4" /> View Details
                                        </button>
                                    </div>
                                    <button
                                        onClick={() => toggleBids(req?._id)}
                                        className="mt-3 text-sm text-blue-600 hover:underline flex items-center gap-2"
                                        disabled={IsbidLoading}
                                    >
                                        {IsbidLoading && expandedJob === req?._id ? (
                                            <>
                                                <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                                                <span>Loading...</span>
                                            </>
                                        ) : expandedJob === req?._id ? (
                                            "Hide Quotation"
                                        ) : (
                                            "Show Quotation"
                                        )}
                                    </button>
                                </div>
                                {expandedJob === req?._id && (
                                    <div className="mt-4 border-t pt-3 space-y-3">
                                        {isUploading ? (
                                            <p className="text-gray-500 text-center">Loading bids...</p>
                                        ) : Allbids?.length === 0 ? (
                                            <p className="text-gray-500 text-center">
                                                No bids found for this material request.
                                            </p>
                                        ) : (
                                            Allbids?.map((bid) => {
                                                const totalAmount = bid?.QuotedItems?.reduce(
                                                    (sum, item) => sum + (item?.totalPrice || 0),
                                                    0
                                                );
                                                const totalWithGST = totalAmount + (totalAmount * (bid?.GST || 0)) / 100;

                                                return (
                                                    <div
                                                        key={bid?._id}
                                                        className="border border-gray-200 rounded-xl bg-white shadow-sm hover:shadow transition text-sm">
                                                        <div className="flex justify-between items-center px-4 py-2 border-b">
                                                            <span className="font-semibold text-gray-800 flex items-center gap-1">
                                                                📦 Supplier Quote
                                                            </span>
                                                            <span
                                                                className={`px-2 py-0.5 text-xs font-medium rounded-full ${bid?.Status === "Pending"
                                                                        ? "bg-yellow-100 text-yellow-700"
                                                                        : bid?.Status === "Accepted"
                                                                            ? "bg-green-100 text-green-700"
                                                                            : "bg-red-100 text-red-700"
                                                                    }`}
                                                            >
                                                                {bid?.Status}
                                                            </span>
                                                        </div>
                                                        <div className="px-4 py-2 overflow-x-auto">
                                                            <table className="w-full text-xs">
                                                                <thead>
                                                                    <tr className="text-gray-600 text-[11px] border-b">
                                                                        <th className="text-left py-1">Item</th>
                                                                        <th className="text-center py-1">Qty</th>
                                                                        <th className="text-center py-1">Rate</th>
                                                                        <th className="text-right py-1">Total</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {bid?.QuotedItems?.map((item) => (
                                                                        <tr key={item?._id} className="border-b last:border-0">
                                                                            <td className="py-1 font-medium text-gray-800">
                                                                                {item?.materialName}
                                                                                <div className="text-[10px] text-gray-500">
                                                                                    {item?.brand || "N/A"} • {item?.specifications}
                                                                                </div>
                                                                            </td>
                                                                            <td className="py-1 text-center">{item?.quantity} {item?.unit}</td>
                                                                            <td className="py-1 text-center">₹{item?.pricePerUnit}</td>
                                                                            <td className="py-1 text-right font-semibold text-gray-800">
                                                                                ₹{item?.totalPrice}
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div className="px-4 py-2 bg-gray-50 border-t text-xs text-gray-700">
                                                            <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mb-2">
                                                                <span>🧾 GST: <b>{bid?.GST}%</b></span>
                                                                <span>⏳ Delivery: <b>{bid?.DeliveryTime}</b></span>
                                                                <span>💳 Credit: <b>{bid?.CreditTerms}</b></span>
                                                                <span>🕒 {new Date(bid?.createdAt).toLocaleDateString()}</span>
                                                            </div>
                                                            <div className="flex justify-between text-xs font-semibold text-gray-800">
                                                                <span>Total (excl. GST):</span>
                                                                <span>₹{totalAmount}</span>
                                                            </div>
                                                            <div className="flex justify-between text-xs font-semibold text-green-600">
                                                                <span>Total (incl. GST):</span>
                                                                <span>₹{totalWithGST}</span>
                                                            </div>
                                                            {bid?.Note && (
                                                                <p className="mt-1 text-gray-600 text-[11px] italic">
                                                                    📝 {bid?.Note}
                                                                </p>
                                                            )}
                                                            <div className="flex justify-end mt-2">
                                                                <button
                                                                onClick={() => UserSelectMaterialSupplierBid(req?._id, bid?._id)}
                                                                    className="px-3 py-1 text-xs bg-green-500 text-white rounded-md hover:bg-green-600 transition"
                                                                >
                                                                    ✅ Select
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        )}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <UpdateMaterialRequestModel
                isOpen={UpdateModel}
                onClose={CloseUpdateModel}
                Requestdata={SelectedReq}
                GetUserAllPendingMaterialRequest={GetUserAllPendingMaterialRequest}
            />
            <DeleteMaterialRequestModel
                isOpen={DeleteModel}
                onClose={CloseDeleteModel}
                Requestdata={SelectedReq}
                GetUserAllPendingMaterialRequest={GetUserAllPendingMaterialRequest}
            />
        </div>
    )
}

export default UserAllPendingMaterialRequest